import React from 'react';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  textareaSchema,
  textareaUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Section V: Remarks'),
    'ui:description': (
      <div>
        <VaAlert status="info" className="vads-u-margin-top--3" uswds visible>
          <h2 slot="headline">
            <b>What to expect:</b>
          </h2>
          <div className="vads-u-margin--0">
            <ul style={{ marginBottom: 0 }}>
              <li>Space for any additional details about your situation</li>
              <li>Space for uploading documentation</li>
              <li>This section is optional</li>
            </ul>
          </div>
        </VaAlert>
        <div className="vads-u-margin-top--5">
          <h2 className="vads-u-font-size--h3" style={{ marginTop: 0 }}>
            Your remarks
          </h2>
        </div>
      </div>
    ),

    additionalRemarks: textareaUI({
      title: 'Enter additional information about your situation. (Optional)',
      rows: 5,
      maxlength: 1000,
      charcount: true,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      additionalRemarks: {
        ...textareaSchema,
        maxLength: 1000,
      },
    },
  },
};
